// The loose React shim forbids named imports; expose the hooks the owner app needs with light typings.
import React from 'react';
const R = React as any;
export { useState, useEffect, useRef, useMemo, useCallback, useContext, createContext, useId } from '../ui/react';
export const useSyncExternalStore: <T>(subscribe: (cb: () => void) => () => void, getSnapshot: () => T, getServerSnapshot?: () => T) => T = R.useSyncExternalStore;
export const useLayoutEffect: (fn: () => void | (() => void), deps?: unknown[]) => void = R.useLayoutEffect;
export const useReducer: <S>(r: (s: S, a: any) => S, init: S) => [S, (a: any) => void] = R.useReducer;
export const Fragment: any = R.Fragment;
export const Component: any = R.Component;
export const memo: <T>(c: T) => T = R.memo;
export const flushSync: (fn: () => void) => void = (R as any).flushSync ?? ((fn: () => void) => fn());
